import { LOGIN_FAIL, LOGIN_SUCCESS } from './types';


export const setUser = (user) => dispatch => {
  try {
    dispatch({
        payload:user,
        type: LOGIN_SUCCESS,
      });
  } catch (error) {
    // This catch block may not be executed as expected
    dispatch({
      type: LOGIN_FAIL,
    });
  }
};
export const deleteUser = (user) => dispatch => {
  try {
    dispatch({
         
        type: LOGIN_FAIL
      });
  } catch (error) {
    // This catch block may not be executed as expected
    dispatch({
      type: LOGIN_FAIL
    });
  }
};
